import { ServerError } from '@cp/utils/rtk/query/model';
import { HttpStatusCode } from '@cp/utils/const/httpStatusCode';

export interface PaymentRequiredError extends ServerError {
  status: HttpStatusCode.PaymentRequired;
}
export const isPaymentRequiredError = <T>(err: ServerError): err is PaymentRequiredError => err.status === HttpStatusCode.PaymentRequired;
type PaymentCallback = (err: PaymentRequiredError) => void | Promise<void>;

export interface WithPaymentCallback {
  onPaymentRequired?: PaymentCallback;
}
